'use client'
import type { NextPage } from "next";
import React, { useState, useEffect } from 'react';
import Link from "next/link";
import Image from 'next/image';
import sports from '../../../public/sports.jpg'
import { SearchBar } from '../SearchBar/searchBar'
import moment from 'moment'
import { IoSearch } from "react-icons/io5";
import { Oswald, Roboto } from 'next/font/google';
import { RiArrowRightSLine } from "react-icons/ri";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axios from "axios";
import { usePathname } from "next/navigation";
import { useAppSelector } from "@/redux/store";

let url: any;
if (typeof window !== "undefined") {
  url = localStorage.getItem("Frontend_API");
}

let domain_url: any;
if (typeof window !== "undefined") {
  domain_url = localStorage.getItem("domain_url");
}

// let displayCount = 10;


interface Findmore {
  id: number;
  name: string;

}

interface imageInfo {
  eventId: number;
  image_url: string;
}


interface FindmoreProps {
  findmore: Findmore[];
  imageInfo: imageInfo[];
  performer_id?: number;
  showHomeAway?: boolean;
}


const oswalds = Oswald({ subsets: ['latin'] })
const roboto = Roboto({ weight: ['300', '400', '500', '700', '900'], subsets: ['latin'] })

function formatDate(inputDate: any) {
  const date = new Date(inputDate);
  const day = date.getUTCDate();
  const month = date.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' }).toUpperCase();
  const formattedDate = `${day} ${month}`;
  return formattedDate;
}


function formatDay(inputDate: any): string {
  const date = new Date(inputDate);

  const dayName = date.toLocaleString('en-US', { weekday: 'short', timeZone: 'UTC' });

  return dayName;
}





function formatTime(inputDate: any): string {

  // Parse the input date using Moment.js
  const momentDate = moment.parseZone(inputDate);

  // Format the time using Moment.js
  const formattedTime = momentDate.format('hh:mm A');

  return formattedTime;
}






export const Findmore: NextPage<FindmoreProps> = ({ findmore, imageInfo, performer_id, showHomeAway }) => {

  const [loading, setLoading] = useState(false);
  const [findMoreData, setFindMoreData] = useState(findmore);
  const [imageInfoData, setImageInfoData] = useState(imageInfo);
  const [displayCount, setDisplayCount] = useState(10);
  const [userCity, setUserCity] = useState('');
  const currentPath = usePathname();
  const [isLoading, setIsLoading] = useState(false);
  const isPWA = useAppSelector((state: any) => state.pwacheckReducer.isPWA);
  const [isHome, setIsHome] = useState(true);
  const [hasMoreData, setHasMoreData] = useState(true);
  let isFetching = false;
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    if (!(currentPath.includes('venue'))) {

      navigator.geolocation.getCurrentPosition(async (position) => {
        //console.log('lat from geolocation',position.coords.latitude);
        //console.log('lon from geolocation',position.coords.longitude);

        try {
          const response = await axios.get(`${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_URL}`,
            {
              params: {
                latlng: `${position.coords.latitude},${position.coords.longitude}`,
                key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
              },
            }
          );

          const data = response.data;

          if (data.status === 'OK') {
            const results = data.results;
            const city = results.find((result: any) =>
              result.types.includes('locality')
            )?.address_components[0].long_name;

            if (city) {
              console.log('City:', city);
              setUserCity(city);
            } else {
              console.log('City not found');
            }
          } else {
            console.error('Geocoding API error:', data.status);
          }

          //console.log('response from geolocation',response);

        } catch (error) {
          console.error('Error from geolocation', error);
        }
      });

    }
  }, []);


  useEffect(() => {
    if (userCity) {
      sortDataBasedOnCity(findmore);
    } else {
      setFindMoreData(findmore);
    }
    setImageInfoData(imageInfo);
    setDisplayCount(10);
  }, [findmore, imageInfo, userCity]);

  // useEffect(() => {
  //   if (displayCount > 10) {
  //     fetchData(displayCount);
  //   }
  // }, [displayCount]);

  const handleLoadMore = (page: number) => {
    setPage(page);
    fetchData(page, isHome);
  };

  const handleToggle = async (value: string) => {
    if (value === 'true') {
      setIsHome(true);
    } else {
      setIsHome(false);
    }
    setFindMoreData([]);
    setImageInfoData([]);
    setPage(1);
    fetchData(1, value == 'true' ? true : false);
    console.log(`Selected option: ${value}`); // Log the selected value
  };


  const handleLoad = () => {
    setIsLoading(true);
    setTimeout(() => {
      setDisplayCount((prevCount) => prevCount + 10);
      setIsLoading(false);
    }, 1000); // Simulate a 1-second loading time
  };



  const sortDataBasedOnCity = (eventData: any) => {
    const sortedData = [...eventData].sort((a: any, b: any) => {
      const venueA = a.venue.location.toLowerCase();
      const venueB = b.venue.location.toLowerCase();
      const userCityLower = userCity.toLowerCase();

      if (venueA.includes(userCityLower) && !venueB.includes(userCityLower)) {
        return -1;
      }
      if (!venueA.includes(userCityLower) && venueB.includes(userCityLower)) {
        return 1;
      }
      return 0;
    });

    console.log('sorted data from geolocation', sortedData);

    setFindMoreData(sortedData);
  }


  const fetchData = async (page: number, isHome: boolean) => {
    if (isFetching) return;
    isFetching = true;
    let mes1;
    if (showHomeAway) {
      mes1 = `GET ${domain_url}/v9/events?${currentPath.includes('venue') ? 'venue_id' : 'performer_id'}=${performer_id}&per_page=${limit}&page=${page}&primary_performer=${isHome}`;
    } else {
      mes1 = `GET ${domain_url}/v9/events?${currentPath.includes('venue') ? 'venue_id' : 'performer_id'}=${performer_id}&per_page=${limit}&page=${page}`;
    }
    const mes = mes1;
    try {
      setLoading(true);
      const SignatureResponse = await fetch(`${url}/api/signature`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mes),
      });
      const data = await SignatureResponse.json();
      console.log("signature of thisWeekend", data);
      let query1;
      if (showHomeAway) {
        query1 = `${currentPath.includes('venue') ? 'venue_id' : 'performer_id'}=${performer_id}&per_page=${limit}&page=${page}&primary_performer=${isHome}`
      } else {
        query1 = `${currentPath.includes('venue') ? 'venue_id' : 'performer_id'}=${performer_id}&per_page=${limit}&page=${page}`
      }
      const response = await fetch(`${url}/api/getEvents`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          signature: data.msg,
          query: query1,
        }),
      });
      const result = await response.json();
      console.log("response from events Api in thisWeekend", result.data);
      console.log("this is the image info", result.imageInfo);
      setFindMoreData((prev) => [...prev, ...result.data]);
      setImageInfoData((prev) => [...prev, ...result.imageInfo]);
      setHasMoreData(result.data.length > 0);
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
      isFetching = false;
    }
  }

  return (


    <div className="flex justify-center items-center bg-[#fafbfb] mb-4">
      {
        (loading) &&
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 bg-white w-screen h-screen">
          <div className='w-full h-full absolute flex items-center justify-center text-black'><LoadingAnimation /></div>
        </div>
      }
      {!isPWA && (
        <div className="justify-center items-center flex-col gap-4 flex w-full max-w-[1200px] px-4">

          {/* <div className="flex flex-col md:flex-row gap-4 w-full"> */}
          {/* {findmore.length === 0 ? null :  <SearchBar className="md:w-[378px] w-full flex flex-col relative gap-10" styles={{ divstyle: { border: '2px solid #989797', borderRadius: '35px' } }} />} */}
          {/* <div className="flex items-center w-full md:w-[500px] border-2 border-neutral-400 rounded-2xl bg-white">
         <IoSearch className="h-6 w-6 mx-2 my-1" />
         <input
           type="text"
           className="w-full outline-none text-sm text-gray-700 max-md:text-[13px] placeholder-gray-700"
           placeholder="Search by teams, artist, event or venue"
         />
       </div> */}

          {/* <div className="flex gap-6 overflow-x-auto mt-4 md:mt-0 flex-nowrap" style={{ WebkitOverflowScrolling: 'touch', msOverflowStyle: '-ms-autohiding-scrollbar' }}>
         <div className="flex-none w-auto whitespace-nowrap">
           <select className="px-3 py-1 md:px-6 md:py-2 md:w-[250px] rounded-2xl border border-neutral-400 hover:text-black-500 focus:outline-none font-bold text-gray-500">
             <option value="this_weekend">CATEGORIES</option>
           </select>
         </div>

         <div className="flex-none w-auto whitespace-nowrap">
           <select className="px-3 py-1 md:px-6 md:py-2 md:w-[200px] rounded-2xl border border-neutral-400 hover:text-black-500 focus:outline-none font-bold text-gray-500">
             <option value="this_weekend">THIS MONTH</option>
           </select>
         </div>

         <div className="flex-none w-auto whitespace-nowrap">
           <select className="px-3 py-1 md:px-6 md:py-2  rounded-2xl border border-neutral-400 hover:text-black-500 focus:outline-none font-bold text-gray-500">
             <option value="this_weekend">VENUE</option>
           </select>
         </div>
       </div> */}

          {/* <div className="inline-block text-left">
     <select className="px-6 py-2  md:w-[250px] rounded-2xl border border-neutral-400 hover:text-black-500 focus:outline-none font-bold text-gray-500">
       <option value="this_weekend">CATEGORIES</option>
     </select>
   </div>

   <div className="inline-block text-left">
     <select className="px-6 py-2  md:w-[200px] rounded-2xl border border-neutral-400 hover:text-black-500 focus:outline-none font-bold text-gray-500">
       <option value="this_weekend">THIS MONTH</option>
     </select>
   </div>

   <div className="inline-block text-left">
     <select className="px-6 py-2  md:w-[190px] rounded-2xl border border-neutral-400 hover:text-black-500 focus:outline-none font-bold text-gray-500">
       <option value="this_weekend">VENUE</option>
     </select>
   </div> */}

          {/* </div> */}
          {showHomeAway && (
            <div className="flex flex-col md:flex-row gap-4 w-full justify-center mt-[20px]">
              <div className="flex flex-col md:flex-row gap-4 w-full justify-center mt-[20px]">
                <div className="flex gap-4 items-center justify-center">
                  <button
                    className={`px-6 py-2 text-[#ff7f1e] rounded-3xl border-2 border-[#ff7f1e] focus:outline-none focus:ring-2 focus:ring-orange-500 ${isHome ? 'bg-orange-100 text-[#ff7f1e]' : 'bg-white border-gray-300'
                      } w-[300px]`}
                    onClick={() => handleToggle('true')}
                  >
                    HOME GAMES
                  </button>
                  <button
                    className={`px-6 py-2 text-[#ff7f1e] rounded-3xl border-2 border-[#ff7f1e] focus:outline-none focus:ring-2 focus:ring-orange-500 ${!isHome ? 'bg-orange-100 text-[#ff7f1e]' : 'bg-white border-gray-300'
                      } w-[300px]`}
                    onClick={() => handleToggle('false')}
                  >
                    AWAY GAMES
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className={`w-full lg:w-[1000px] flex flex-col ${roboto.className} justify-center gap-4`}>


            {typeof isHome === 'undefined' && findMoreData.length === 0 ? (
              <div className="text-xl font-bold flex flex-col justify-center items-center gap-2 mb-24">
                <Image src="/calender.gif" width={500} height={500} alt="calender" />
                <div className="text-xl font-bold">You have no upcoming events</div>
                <Link href="/">
                  <button className='bg-[#397BEA] hover:bg-[#3977ea] text-white text-bold rounded-full py-2 px-4 text-2xl'>Discover Events</button>
                </Link>
              </div>
            ) : isHome && findMoreData.length === 0 ? (
              <div className="text-xl font-bold flex flex-col justify-center items-center gap-2 mb-24">
                <Image src="/calender.gif" width={500} height={500} alt="calender" />
                <div className="text-xl font-bold">You have no Home Games</div>
                {/* <Link href="/">
                  <button className='bg-[#397BEA] hover:bg-[#3977ea] text-white text-bold rounded-full py-2 px-4 text-2xl'>Discover Events</button>
                </Link> */}
              </div>
            ) : !isHome && findMoreData.length === 0 ? (
              <div className="text-xl font-bold flex flex-col justify-center items-center gap-2 mb-24">
                <Image src="/calender.gif" width={500} height={500} alt="calender" />
                <div className="text-xl font-bold">You have no Away Games</div>
                {/* <Link href="/">
                  <button className='bg-[#397BEA] hover:bg-[#3977ea] text-white text-bold rounded-full py-2 px-4 text-2xl'>Discover Events</button>
                </Link> */}
              </div>
            ) :
              (findMoreData.length > 0 && findMoreData.map((dataItem: any, index) => (

                // eslint-disable-next-line react/jsx-key
                <div key={dataItem.id}>
                  <Link href={`/viewtickets1/${dataItem.id}`}>
                    <div className={`md:p-2 bg-white rounded-lg justify-between items-center flex transition hover:bg-gray-100 duration-300 hover:shadow-sm hover:scale-[1.02]`} onClick={() => setLoading(true)}>
                      <div className="justify-start items-center md:gap-4 lg:gap-8 gap-2 flex">

                        {imageInfoData[index]?.eventId === dataItem.id ? (
                          <Image src={imageInfoData[index].image_url} alt="broadway1" width={300} height={150} className="rounded-lg shrink-0 object-cover w-[96px] h-[96px]" />
                        ) : (
                          <Image src={sports} alt="artist" className="rounded-lg shrink-0 object-cover w-[96px] h-[96px]" />
                        )}
                        {/* <Image src="/family1.png" alt="family1" width={24} height={24} className="w-24 h-24 rounded-lg object-cover" /> */}
                        <div className="flex-col justify-start items-start gap-4 w-[200px] lg:w-[200px] md:w-[170px]">
                          <div className={`text-[#201D1D] text-xs md:text-base font-bold ${roboto.className} leading-none`}>
                            {dataItem.name}
                          </div>
                          <div className="text-[#201D1D] text-xs font-normal  leading-none">{dataItem?.venue?.name}</div>
                          <div className="text-[#201D1D] text-xs font-normal  leading-none">{dataItem?.venue?.location}</div>
                          <div className="text-[#011E7B] text-xs font-bold md:hidden">{formatDate(dataItem?.occurs_at)}</div>
                          <div className="text-[#6A6868] text-[11px] md:hidden">{formatDay(dataItem?.occurs_at)}.{formatTime(dataItem?.occurs_at)}</div>
                        </div>
                      </div>


                      <div className="justify-between items-center md:flex hidden">
                        <div className="flex-col justify-start items-start gap-2 inline-flex">
                          <div className="text-[#201D1D] text-base font-bold  leading-tight">{formatDate(dataItem?.occurs_at)}</div>
                          <div className="text-[#6A6868] text-xs font-normal  leading-none">{formatDay(dataItem?.occurs_at)}.{formatTime(dataItem?.occurs_at)}</div>
                        </div>
                      </div>

                      <div className="hidden md:flex p-2 md:pl-1 md:pr-2 md:pt-0 md:pb-0 bg-orange-500 rounded-full md:rounded-none justify-center items-center gap-2.5 md:gap-[0px] lg:gap-2.5">
                        <div className="md:w-7 md:h-7 justify-center items-center flex">
                          <div className="w-5 h-5 relative overflow-hidden">
                            <img className="w-full h-full object-cover" alt="" src="/Seat Icon1.svg" />
                          </div>
                        </div>
                        <div className="text-white text-base font-semibold leading-tight flex">{dataItem?.available_count} <span className="md:flex hidden">&#160; Tickets Remaining</span></div>
                      </div>

                      <div className='md:hidden w-[66px] h-[46px] flex flex-col justify-center items-center'>
                        <div className="p-1.5 w-[24px] h-[24px] bg-orange-500 rounded-full">
                          <img className="w-[13px] h-[9px] object-cover" alt="" src="/Seat Icon1.svg" />
                        </div>
                        <div className=' text-orange-500'>
                          <div className={`${roboto.className} w-[66px] text-[0.75rem] font-bold text-center`}>
                            <div>Tickets</div>
                            <div>Remaining</div>
                          </div>
                          <div className='w-[66px] text-[0.75rem] font-bold text-center'>{dataItem?.available_count}</div>
                        </div>
                      </div>

                      <div className="justify-center items-start gap-2 flex">
                        {/* <Link href={`/viewtickets1/${dataItem.id}`}> */}
                        <div className="md:py-2 rounded-2xl justify-center items-center gap-2.5 flex ">

                          <div className="text-blue-500 text-lg font-bold leading-snug md:flex hidden">View tickets</div>

                          <img className="w-4 h-4 md:w-6 md:h-6" alt="" src="/arrow-down.svg" />

                        </div>
                        {/* </Link> */}

                      </div>

                    </div>
                  </Link>

                </div>
              )))}

          </div>
          {hasMoreData && findMoreData.length > 0 && findMoreData.length % limit === 0 && (
            <div className="flex justify-center items-center my-4">
              <button
                onClick={() => handleLoadMore(page + 1)}
                className="bg-blue-100 text-black px-4 py-2 rounded mr-3 hover:bg-orange-500 hover:text-white"
                style={{ width: '140px' }}
              >
                Show More...
              </button>
            </div>
          )}
        </div>
      )}
      {isPWA && (
        <div className="justify-center items-center flex-col gap-4 flex w-full max-w-[1200px] px-4">
          {showHomeAway && (
            <div className="flex flex-col md:flex-row gap-4 w-full justify-center mt-[20px]">
              <div className="flex flex-col md:flex-row gap-4 w-full justify-center mt-[20px]">
                <div className="flex gap-4 items-center justify-center">
                  <button
                    className={`px-6 py-2 text-[#ff7f1e] rounded-3xl border-2 border-[#ff7f1e] focus:outline-none focus:ring-2 focus:ring-orange-500 ${isHome ? 'bg-orange-100 text-[#ff7f1e]' : 'bg-white border-gray-300'
                      } w-[300px]`}
                    onClick={() => handleToggle('true')}
                  >
                    HOME GAMES
                  </button>
                  <button
                    className={`px-6 py-2 text-[#ff7f1e] rounded-3xl border-2 border-[#ff7f1e] focus:outline-none focus:ring-2 focus:ring-orange-500 ${!isHome ? 'bg-orange-100 text-[#ff7f1e]' : 'bg-white border-gray-300'
                      } w-[300px]`}
                    onClick={() => handleToggle('false')}
                  >
                    AWAY GAMES
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* <div className="flex flex-col md:flex-row gap-4 w-full">

          </div> */}

          <div className={`w-full lg:w-[1000px] flex flex-col ${roboto.className} justify-center gap-4`}>

          {typeof isHome === 'undefined' && findMoreData.length === 0 ? (
              <div className="text-xl font-bold flex flex-col justify-center items-center gap-2 mb-24">
                <Image src="/calender.gif" width={500} height={500} alt="calender" />
                <div className="text-xl font-bold">You have no upcoming events</div>
                <Link href="/">
                  <button className='bg-[#397BEA] hover:bg-[#3977ea] text-white text-bold rounded-full py-2 px-4 text-2xl'>Discover Events</button>
                </Link>
              </div>
            ) : isHome && findMoreData.length === 0 ? (
              <div className="text-xl font-bold flex flex-col justify-center items-center gap-2 mb-24">
                <Image src="/calender.gif" width={500} height={500} alt="calender" />
                <div className="text-xl font-bold">You have no Home Game</div>
                {/* <Link href="/">
                  <button className='bg-[#397BEA] hover:bg-[#3977ea] text-white text-bold rounded-full py-2 px-4 text-2xl'>Discover Events</button>
                </Link> */}
              </div>
            ) : !isHome && findMoreData.length === 0 ? (
              <div className="text-xl font-bold flex flex-col justify-center items-center gap-2 mb-24">
                <Image src="/calender.gif" width={500} height={500} alt="calender" />
                <div className="text-xl font-bold">You have no Away Game</div>
                {/* <Link href="/">
                  <button className='bg-[#397BEA] hover:bg-[#3977ea] text-white text-bold rounded-full py-2 px-4 text-2xl'>Discover Events</button>
                </Link> */}
              </div>
            ) : (findMoreData.length > 0 && findMoreData.map((dataItem: any, index) => (

              // eslint-disable-next-line react/jsx-key
              <div key={dataItem.id}>
                <Link href={`/viewtickets1/${dataItem.id}`}>
                  <div className="md:p-2 bg-white rounded-lg flex items-center justify-between transition hover:bg-gray-100 duration-300 hover:shadow-sm hover:scale-[1.02]" onClick={() => setLoading(true)}>
                    <div className="flex items-center md:gap-4 lg:gap-8 gap-2">
                      <div className="w-[96px] h-[96px] flex flex-col items-center justify-center rounded-lg text-[#201D1D]">
                        <div className="text-base font-bold">{formatDate(dataItem?.occurs_at)}</div>
                        <div className="text-xs text-[#8a98c2] font-bold">{formatDay(dataItem?.occurs_at)}</div>
                        <div className="text-xs text-[#8a98c2] font-bold">{formatTime(dataItem?.occurs_at)}</div>
                      </div>
                      <div className="flex-col justify-start items-start gap-2 w-[200px] lg:w-[200px] md:w-[170px] ">
                        <div className="mt-1">
                          <div className={`text-[#201D1D] text-xs md:text-base font-bold ${roboto.className} leading-none`}>
                            {dataItem.name}
                          </div>
                          <div className="mt-1">
                            <div className="text-[#6a6868] text-xs font-normal leading-none">
                              {dataItem?.venue?.name} | {dataItem?.venue?.location}
                            </div>
                          </div>
                        </div>
                        <div className="mt-1">
                          <div className="h-6 w-[110px] px-1 py-0.5 bg-[#fff2e9] rounded-[27px] flex items-center gap-1">
                            <div className="w-4 h-4 relative">
                              <img className="w-[15px] h-[15px] object-cover" alt="" src="/ticket-2.svg" />
                            </div>
                            <div className="text-[#ff7f1e] text-[10px] font-normal font-['Roboto'] leading-[12px]">
                              {dataItem?.available_count} Tickets Left
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className="justify-center items-start gap-2 flex mr-[17px]">
                      <div className="md:py-2 rounded-2xl justify-center items-center gap-2.5 flex">
                        <div className="p-1.5 w-[24px] h-[24px] bg-[#e6e9f2] rounded-full">
                          <img className="w-4 h-4 md:w-6 md:h-6" alt="" src="/arrow-down.svg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>



            )))}

          </div>
          {hasMoreData && findMoreData.length > 0 && findMoreData.length % limit === 0 && (
            <div className="flex justify-center items-center my-4">
              <button
                onClick={() => handleLoadMore(page + 1)}
                className="bg-blue-100 text-black px-4 py-2 rounded mr-3 hover:bg-orange-500 hover:text-white"
                style={{ width: '140px' }}
              >
                Show More...
              </button>
            </div>
          )}
        </div>
      )}

    </div>





  )
}

